import { FieldTypes, Shortcut, ShortcutMap } from '@hb/shared'
import { getAddressShortcut } from './shortcuts'

const createListShortcutMap = (
  itemName: string,
  itemShortcutMap: ShortcutMap | Shortcut,
  numItems = 3,
): ShortcutMap => {
  const children: Record<string, Shortcut | ShortcutMap> = {}
  for (let i = 0; i < numItems; i += 1) {
    children[`${i}`] = { ...itemShortcutMap, name: `${itemName} ${i + 1}` }
  }
  return {
    name: `${itemName}s`,
    shortcut: true,
    children,
  }
}

const collaborativePhysicianShortcutMap: ShortcutMap = {
  name: 'Collaborative Physician',
  shortcut: true,
  children: {
    name: {
      name: 'Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    npi: {
      name: 'NPI',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
  },
}

const affiliatedHospitalShortcutMap: ShortcutMap = {
  name: 'Affiliated Hospital',
  shortcut: true,
  children: {
    name: {
      name: 'Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    npi: {
      name: 'NPI',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    phone: {
      name: 'Phone',
      shortcut: true,
      type: FieldTypes.PHONE,
    },
    address: getAddressShortcut('Address'),
  },
}

export const midwifeNameItems: ShortcutMap = {
  name: 'Name',
  shortcut: true,
  children: {
    name: {
      name: 'Practice Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    fullName: {
      name: 'Referring Full Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    fname: {
      name: 'Referring First Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    lname: {
      name: 'Referring Last Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
  },
}

const midwifeNPIItems: ShortcutMap = {
  name: 'NPI',
  shortcut: true,
  children: {
    referringNpi: {
      name: 'Referring NPI',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    billingNpi: {
      name: 'Billing NPI',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
  },
}

const billingTaxIdShortcut: Shortcut = {
  name: 'Billing Tax ID',
  shortcut: true,
  type: FieldTypes.TEXT,
}

const midwifeAddressItems: ShortcutMap = {
  name: 'Addresses',
  shortcut: true,
  children: {
    claimsAddress: getAddressShortcut('Claims Address'),
    corporateAddress: getAddressShortcut('Corporate Address'),
    servicingAddress: getAddressShortcut('Servicing Address'),
  },
}

const collaborativePhysiciansShortcutMap = createListShortcutMap(
  'Collaborative Physician',
  collaborativePhysicianShortcutMap,
)

const affiliatedHospitalsShortcutMap = createListShortcutMap(
  'Affiliated Hospital',
  affiliatedHospitalShortcutMap,
)

const acceptedPaymentMethodsShortcut: Shortcut = {
  name: 'Accepted Payment Methods',
  shortcut: true,
  type: FieldTypes.TEXTAREA,
}

const licensesShortcutMap: ShortcutMap = createListShortcutMap('License', {
  name: 'License',
  shortcut: true,
  type: FieldTypes.TEXT,
})

const practiceLogoShortcut: Shortcut = {
  name: 'Practice Logo',
  shortcut: true,
  type: FieldTypes.FILE,
}

const practicePhoneShortcut: Shortcut = {
  name: 'Practice Phone',
  shortcut: true,
  type: FieldTypes.PHONE,
}

const medicaidShortcutMap: ShortcutMap = {
  name: 'Medicaid',
  shortcut: true,
  children: {
    referringMedicaidIds: createListShortcutMap('Referring Medicaid ID', {
      name: 'Referring Medicaid ID',
      shortcut: true,
      type: FieldTypes.TEXT,
    }),
    groupMedicaidIds: createListShortcutMap('Group Medicaid ID', {
      name: 'Group Medicaid ID',
      shortcut: true,
      type: FieldTypes.TEXT,
    }),
  },
}

export const midwifeItems: ShortcutMap = {
  name: 'Midwife',
  shortcut: true,
  children: {
    name: midwifeNameItems,
    logo: practiceLogoShortcut,
    npi: midwifeNPIItems,
    billingTaxId: billingTaxIdShortcut,
    addresses: midwifeAddressItems,
    collaborativePhysicians: collaborativePhysiciansShortcutMap,
    affiliatedHospitals: affiliatedHospitalsShortcutMap,
    acceptedPaymentMethods: acceptedPaymentMethodsShortcut,
    licenses: licensesShortcutMap,
    medicaid: medicaidShortcutMap,
  },
}

export const practiceItems: ShortcutMap = {
  name: 'Practice',
  shortcut: true,
  children: {
    name: midwifeNameItems,
    logo: practiceLogoShortcut,
    phone: practicePhoneShortcut,
    addresses: midwifeAddressItems,
  },
}
